import React, { useEffect, useState } from "react";
import { getObligationsForAgreement } from "../apis/obligationApi";
import { Button, Checkbox, Table } from "@mantine/core";
import { getActFrequencyText, getDepartmentText } from "../pages/utilities";

const MasterObForAgreement = ({
  local,
  agreementId,
  onSelectOb,
  createNewObligation,
  dependedOb,
}) => {
  const [obligations, setObligations] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const getMasterObligationsforAgreement = async () => {
      const response = await getObligationsForAgreement({
        local: local,
        agreementId: agreementId,
      });
      console.log(response);
      const obligationsWithDepartmentNames = await Promise.all(
        (response?.obligations || []).map(async (obligation) => ({
          ...obligation,
          departmentName: await getDepartmentText(obligation.department),
        }))
      );

      if (isMounted) {
        setObligations(obligationsWithDepartmentNames);
      }
    };

    getMasterObligationsforAgreement();

    return () => {
      isMounted = false;
    };
  }, [agreementId, local]);
  return (
    <div>
      <Table>
        <thead className="text-center">
          <tr>
            {/* <th style={{ textAlign: "center" }}>select</th> */}
            <th style={{ textAlign: "center" }}>obligation id {"(m)"}</th>
            <th style={{ textAlign: "center" }}>obligation title</th>
            <th style={{ textAlign: "center" }}>description</th>
            <th style={{ textAlign: "center" }}>act. frequency</th>
            <th style={{ textAlign: "center" }}>department</th>
            <th style={{ textAlign: "center" }}>assigned to</th>
            {/* <th style={{ textAlign: "center" }}> draft </th> */}
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {obligations &&
            obligations.map((row) => (
              <tr key={row.id} className={row.draft ? "bg-orange-200" : ""}>
                {/* <td>
                          <input type="checkbox" />
                        </td> */}
                <td>{row.id}</td>
                <td>{row.title}</td>
                <td style={{ textAlign: "center" }}>
                  {row.desc}
                  {/* Truncated description */}
                </td>
                <td>{getActFrequencyText(row.actFrequency)}</td>
                <td>{row.departmentName || "--"}</td>
                <td>{row.assignTo?.name || "--"}</td>
                <td>
                  <Checkbox
                    disabled={row.dependedOb}
                    checked={dependedOb && dependedOb === row.id}
                    onChange={() => {
                      onSelectOb(row.id);
                    }}
                  />
                </td>
                {/* <td>{row.draft? "yes": "no"}</td> */}
              </tr>
            ))}
        </tbody>
      </Table>
      <div className="mt-4 flex  justify-end">
        <Button
          disabled={!dependedOb}
          onClick={(e) => createNewObligation(e)}
          // color="yellow"
          variant="contained"
        >
          Connect
        </Button>
      </div>
    </div>
  );
};

export default MasterObForAgreement;
